import { get } from 'lodash-es';
import { MutationTree } from 'vuex';
import { AxiosError } from 'axios';

import { storageService } from '@/shared/services';
import { getConfig } from '@/shared/configs';
import { IVideoState, IVideoParams } from './video.types';

const videoMutations: MutationTree<IVideoState> = {
  setLoading(state: IVideoState, loading: boolean) {
    state.loading = loading;
  },

  setError(state: IVideoState, error: AxiosError) {
    state.error = get(error, 'response.statusText', '');
  },

  setVideoData(state: IVideoState, videoData: any) {
    state.videoData = videoData;
  },

  setVideoSource(state: IVideoState, videoData: any) {
    state.videoSourceUrl = get(videoData, 'videoUrl.url', '');
    state.videoThumbUrl = get(videoData, 'videoThumbnailUrl.url', '');
  },

  setVideoParams(state: IVideoState, params: IVideoParams) {
    state.allowFastBackward = params.allowFastBackward;
    state.allowFastForward = params.allowFastForward;
    state.playAtLeastOnce = params.playAtLeastOnce;
  },

  setQuizAvailable(state: IVideoState, available: boolean) {
    state.quizAvailable = available;
  },

  setVideoPlaysCount(state: IVideoState, count = 0) {
    state.videoPlaysCount = count !== undefined
      ? count
      : state.videoPlaysCount + 1;

    const seekingMode = JSON.parse(storageService.session.get(getConfig().VIDEO_SEEKING_MODE, '{}'));

    seekingMode.videoPlaysCount = count;
    storageService.session.set(getConfig().VIDEO_SEEKING_MODE, JSON.stringify(seekingMode));
  },

  setAllowFastBackward(state: IVideoState, fastBackward = false) {
    state.allowFastBackward = fastBackward;
    const seekingMode = JSON.parse(storageService.session.get(getConfig().VIDEO_SEEKING_MODE, '{}'));

    seekingMode.allowFastBackward = fastBackward;
    storageService.session.set(getConfig().VIDEO_SEEKING_MODE, JSON.stringify(seekingMode));
  },

  setAllowFastForward(state: IVideoState, fastForward = false) {
    state.allowFastForward = fastForward;
    const seekingMode = JSON.parse(storageService.session.get(getConfig().VIDEO_SEEKING_MODE, '{}'));

    seekingMode.allowFastForward = fastForward;
    storageService.session.set(getConfig().VIDEO_SEEKING_MODE, JSON.stringify(seekingMode));
  },
};

export default videoMutations;
